import { AxiosError } from 'axios'

import consoleMessage from 'shared/utils/helpers/consoleMessage'
import isAxiosError from 'shared/utils/helpers/isAxiosError'
import { httpClient } from 'shared/lib'
import { CheckPriceReponse } from '../types'

export function checkProductPriceService(
   reflinkUuid: string,
   verificationHeader: string,
   productUuid: string,
   quantity: number
) {
   let errMessage = ''
   return httpClient
      .get<CheckPriceReponse>(
         `/client-carts/reflinks/${reflinkUuid}/products?productUuid=${productUuid}&quantity=${quantity}`,
         {
            headers: {
               'X-Reflink-Verification-Code': verificationHeader,
            },
         }
      )
      .then((res) => ({ data: res.data, status: res.status }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CLIENT_CART_REFLINK addProduct service', errMessage, 'error')
         throw error
      })
}
